module.exports = __webpack_public_path__ + "img/datacenter16.cd65ea00.png";